import React from "react";
import { Button } from "semantic-ui-react";
import { generatePdfName } from "utilities/esigningUtils";
import PdfViewerModal from "./modals/PdfViewerModal";

interface Props {
  label: string
  documentNumber: string
  documentId: number
  onValidate?: () => Promise<boolean>
}

const ViewInvoiceButtonPart = (props: Props) => {
  const [displayPdfPreview, setDisplayPdfPreview] = React.useState(false);
  return <>
    <div className="flex gap justify-center padding radius card-floating-bg">
      <div>
        <Button
          color="green"
          onClick={async () => {
            if (props.onValidate) {
              const isValid = await props.onValidate();
              if (!isValid) {
                return;
              }
            }
            setDisplayPdfPreview(true);
          }}>
          {props.label}
        </Button>
      </div>
      <div>
        <Button
          color="blue"
          onClick={async () => {
            if (props.onValidate) {
              const isValid = await props.onValidate();
              if (!isValid) {
                return;
              }
            }

            const fileName = generatePdfName(props.documentNumber);
            window.location.href = window.CoreApi.InvoiceV2.DownloadPdf.absoluteUrl(props.documentId, fileName, false);
          }}>
          {RESX.InvoiceDocument.DownloadInvoice}
        </Button>
      </div>
      {site.deploymentValues.debug && <div><Button
        color="blue"
        onClick={async () => {
          if (props.onValidate) {
            const isValid = await props.onValidate();
            if (!isValid) {
              return;
            }
          }
          window.open(window.CoreApi.InvoiceV2.PreviewDocument.absoluteUrl(props.documentId), "_blank")
        }}
      >
        Preview HTML
      </Button>
      </div>}
    </div>
    <PdfViewerModal
      isOpen={displayPdfPreview}
      onClose={() => { setDisplayPdfPreview(false); }}
      documentId={props.documentId}
      documentNumber={props.documentNumber}
    />
  </>;
};

export default ViewInvoiceButtonPart;
